<div class="grid ">
    <div class="col-12">
        <div class="card">
            <h4>Novo Vínculo</h4>
            <form #form="ngForm" name="form" novalidate>
                <div class="formgroup">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-12">
                            <p-divider></p-divider>
                        </div>
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="tipoBusca">Tipo de busca</label>
                            <p-dropdown [options]="tiposBusca" [(ngModel)]="buscaSelecionada" name="tipoBusca">
                            </p-dropdown>
                        </div>
                        <div class="field col-12 md:col-5" *ngIf="buscaSelecionada == 'E-mail'">
                            <label htmlFor="email">Buscar por e-mail</label>
                            <input type="text" pInputText name="email" placeholder="Digite o e-mail"
                                [(ngModel)]="emailConsulta">
                        </div>
                        <div class="field col-12 md:col-5" *ngIf="buscaSelecionada == 'CPF'">
                            <label htmlFor="email">Buscar por CPF</label>
                            <p-inputMask mask="999.999.999-99" [unmask]="true" type="text" placeholder="000.000.000-00"
                                name="cpf" ngModel #cpf="ngModel" [(ngModel)]="cpfConsulta"> </p-inputMask>
                        </div>
                        <div class="field col-12 md:col-5">
                            <button pButton type="button" class="p-button-outlined mt-5" icon="pi pi-search"
                                (click)="consultarUsuario()" pTooltip="Buscar"></button>
                            <button pButton type="button" class="p-button-outlined ml-2" icon="pi pi-times-circle"
                                (click)="limparUsuario()" pTooltip="Limpar"></button>
                        </div>
                        <div class="field col-12 md:col-12" *ngIf="usuarioSelecionado">
                            <p-divider></p-divider>
                        </div>
                        <div class="field col-12 md:col-4" *ngIf="usuarioSelecionado">
                            <label htmlFor="nome">Nome</label>
                            <input type="text" pInputText [readOnly]="true" [(ngModel)]="usuarioSelecionado.nome"
                                name="nome">
                        </div>
                        <div class="field col-12 md:col-4" *ngIf="usuarioSelecionado">
                            <label htmlFor="email">E-mail</label>
                            <input type="text" pInputText [readOnly]="true" [(ngModel)]="usuarioSelecionado.email"
                                name="email">
                        </div>
                        <div class="field col-12 md:col-4" *ngIf="usuarioSelecionado">
                            <label htmlFor="cpf">CPF</label>
                            <p-inputMask mask="999.999.999-99" type="text" name="cpf" id="cpf" [readonly]="true"
                                [ngModel]="usuarioSelecionado.cpf"></p-inputMask>
                        </div>
                        <div class="field col-12 md:col-12" *ngIf="usuarioSelecionado">
                            <p-divider></p-divider>
                        </div>
                        <div class="field col-12 md:col-2" *ngIf="usuarioSelecionado">
                            <button pButton type="button" class="p-button-primary" icon="pi pi-plus" label="Adicionar"
                                (click)="abrirDialogPermissao()"></button>
                        </div>
                        <div class="col-12 md:col-10">
                        </div>

                        <div class="col-12 md:col-4">
                            <h5>Permissões</h5>

                        </div>
                        <div class="col-12 md:col-6">

                        </div>
                        <div class="col-12 md:col-2" *ngIf="categoriasTreeTableAdicionadasSelecionada.length > 0">
                            <button pButton type="button" class="p-button-danger" icon="pi pi-trash" label="Excluir"
                                ></button>

                        </div>
                        <div class="col-12 md:col-12">
                            <p-treeTable [value]="categoriasTreeTableAdicionadas" [columns]="colunasTreeTableAdicionadas"
                                selectionMode="checkbox" [(selection)]="categoriasTreeTableAdicionadasSelecionada"
                                >
                                <ng-template pTemplate="caption">
                                    <div class="flex">
                                        <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>
                                        <span class="ml-2">Selecionar todas</span>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th *ngFor="let col of columns">
                                            {{col.header}}
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                                    <tr>
                                        <td *ngFor="let col of columns; let i = index">
                                            <p-treeTableToggler [rowNode]="rowNode" *ngIf="i == 0"></p-treeTableToggler>
                                            <p-treeTableCheckbox [value]="rowNode" *ngIf="i == 0"></p-treeTableCheckbox>
                                            {{rowData[col.field]}}
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-treeTable>
                        </div>

                    </div>
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-2" *ngIf="!progressoRequisicao">
                            <button type="submit" pButton icon="pi pi-check" label="Salvar" (click)="SalvarPermissoes()"
                                class="p-button-success mt-5"
                                [disabled]="categoriasTreeTableAdicionadas.length < 1"></button>
                        </div>
                        <div class="field col-12 md:col-2" *ngIf="progressoRequisicao">
                            <button type="submit" pButton icon="pi pi-spin pi-spinner" label="Salvando..."
                                class="p-button-success mt-5" [disabled]="true"></button>
                        </div>
                        <div class="field col-12 md:col-8">

                        </div>
                        <div class="field col-12 md:col-2">
                            <button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
                                class="p-button-primary mt-5" (click)="voltar()"></button>
                        </div>
                    </div>
                </div>
            </form>
            <p-dialog header="Adicionar Permissão" [(visible)]="exibirDialogPermissao" [modal]="true"
                [style]="{width: '50vw'}" [draggable]="false" [resizable]="false" [closable]="true">
                <div class="flex justify-content-center" *ngIf="exibirSpinnerDialog">
                    <p-progressSpinner></p-progressSpinner>
                </div>
                <p-treeTable #dt2 [value]="categoriasTreeTable" [columns]="colunasTreeTable" selectionMode="checkbox"
                    [(selection)]="categoriasTreeTableSelecionada" *ngIf="!exibirSpinnerDialog">
                    <ng-template pTemplate="caption">
                        <div class="flex justify-content-between flex-column sm:flex-row">

                            <div>
                                <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>
                                <span class="ml-2">Selecionar todas</span>
                            </div>
                            <div>
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input pInputText class="w-full" type="text" #filter (input)="buscar(dt2, $event)"
                                        placeholder="Buscar" />
                                </span>
                                <span class="ml-2">
                                    <button pButton class="p-button-outlined" icon="pi pi-filter-slash"
                                        pTooltip="Limpar Filtros" (click)="limpar(dt2)"></button>
                                </span>
                            </div>
    
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngFor="let col of columns">
                                {{col.header}}
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                        <tr>
                            <td *ngFor="let col of columns; let i = index">
                                <p-treeTableToggler [rowNode]="rowNode" *ngIf="i == 0"></p-treeTableToggler>
                                <p-treeTableCheckbox [value]="rowNode" *ngIf="i == 0"></p-treeTableCheckbox>
                                {{rowData[col.field]}}
                            </td>
                        </tr>
                    </ng-template>
                </p-treeTable>

                <ng-template pTemplate="footer">
                    <button type="button" pButton icon="pi pi-check" label="Adicionar" class="p-button-success mt-2"
                        (click)="adicionarPermissao()"></button>
                </ng-template>
            </p-dialog>
            <p-dialog header="Cadastrar Usuário" [(visible)]="exibirDialogNovoUsuario" [modal]="true"
				[style]="{width: '50vw'}" [draggable]="false" [resizable]="false" [closable]="false">
				<form #formUsuario="ngForm" name="formuUsuario">
					<div class="formgroup" *ngIf="novoUsuario">
						<div class="p-fluid p-formgrid grid">
							<div *ngIf="exibirMensagemNovoUsuario" class="field col-12 md:col-12">
								<p-messages [(value)]="mensagemNovoUsuario" [enableService]="false" [closable]="true"></p-messages>
							</div>
							<div class="field col-12 md:col-3">
								<label htmlFor="cpfUsuario">CPF</label>
								<p-inputMask mask="999.999.999-99" [unmask]="true" type="text" placeholder="000.000.000-00"
									name="cpfUsuario" ngModel #cpfUsuario="ngModel" [(ngModel)]="novoUsuario.cpf"
									>
								</p-inputMask>
							</div>
							<div class="field col-12 md:col-9">
								<label htmlFor="nomeUsuario">Nome</label>
								<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
									name="nomeUsuario" [(ngModel)]="novoUsuario.nome" required>
							</div>
							<div class="field col-12 md:col-3">
								<label htmlFor="apelido">Apelido</label>
								<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
									name="apelido" [(ngModel)]="novoUsuario.apelido">
							</div>
							<div class="field col-12 md:col-6">
								<label htmlFor="emailUsuario">E-mail</label>
								<input pInputText type="email" placeholder="seuemail@mail.com" name="emailUsuario"
								 ngModel email="true" #emailUsuario="ngModel" [(ngModel)]="novoUsuario.email"
								(input)="verificarEmailUsuario(emailUsuario.hasError('email'))" required/>
								<div *ngIf="emailUsuario.hasError('email')" class="alerta">
									<small>Digite um e-mail válido</small>
								</div>
								<div *ngIf="!emailValido && novoUsuario.email" class="alerta">
									<small>Email já está em uso</small>
								</div>
							</div>
							<div class="field col-12 md:col-3">
								<label htmlFor="fonePessoal">Fone Pessoal</label>
								<p-inputMask mask="(99) 99999-9999" [unmask]="true" type="text"
									placeholder="(99) 99999-9999" name="fonePessoal" ngModel #fonePessoal="ngModel"
									[(ngModel)]="novoUsuario.whatsapp">
								</p-inputMask>
							</div>
						</div>
					</div>
				</form>
				
				<div class="p-fluid p-formgrid grid justify-content-between">
					<div class="field col-12 md:col-3"  *ngIf="!progressoNovoUsuario">
						<button type="button" pButton icon="pi pi-check" label="Cadastrar"
							class="p-button-success" (click)="cadastrarUsuario()"
							[disabled]="!formUsuario.valid || !emailValido">
						</button>
					</div>
					<div class="field col-12 md:col-3" *ngIf="progressoNovoUsuario">
						<button type="submit" pButton icon="pi pi-spin pi-spinner" label="Cadastrando..."
							class="p-button-success mt-5" [disabled]="true"></button>
					</div>
					<div class="field col-12 md:col-3">
						<button type="button" pButton icon="pi pi-times" label="Cancelar" class="p-button-primary"
							(click)="exibirDialogNovoUsuario = false" ></button>
					</div>
				</div>
			</p-dialog>
        </div>
    </div>
</div>